import { updateItemInCollection } from "directus/src/operations";

export async function createBucketConfig({ jobId, values }) {
  try {
    const query = {
      fields: ["id", "bucket_job_config.id", "bucket_job_config.amount", "bucket_job_config.currency", "bucket_job_config.hours"],
    };

    const response = await updateItemInCollection(
      "jobs",
      jobId,
      {
        bucket_job_config: values,
      },
      query
    );
    return response;
  } catch (error) {
    console.error("Error creating bucket config:", error);
    throw error;
  }
}

export async function updateBucketConfig({ id, values }) {
  try {
    const query = {
      fields: ["id", "amount", "currency", "hours"],
    };

    const response = await updateItemInCollection(
      "bucket_job_config",
      id,
      values,
      query
    );
    return response;
  } catch (error) {
    console.error("Error updating bucket config:", error);
    throw error;
  }
}
